export default "__VITE_ASSET__DHkMQvNi__"